import { NgModule } from '@angular/core';

import { NgxMaskModule } from 'ngx-mask';

import { MaterialModule } from '../../modules/material.module';
import { SharedModule } from '../../modules/shared.module';
import { PercentControlComponent } from './percent-control.component';

@NgModule({
  imports: [
    SharedModule,
    NgxMaskModule,
    MaterialModule
  ],
  declarations: [
    PercentControlComponent
  ],
  exports: [
    PercentControlComponent
  ]
})
export class PercentControlModule  {}
